<template>
  <v-app :class="[sidebarIsOpened, $router.currentRoute.name === 'group' && 'group-page-members-list-page']"
    v-touch="{
      left: (e) => swipe({dir: 'left', ev: e}),
      right: (e) => swipe({dir: 'right', ev: e})
    }">
    <router-view></router-view>
    <Footer :paddingLeft="paddingLeft"
            :key="renderingFooterPadding" />
  </v-app>
</template>

<script>
import Footer from './components/global/Footer.vue'
import VueJwtDecode from 'vue-jwt-decode'
function decodeJwtToken () {
  const token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token)
  }
  return null
}
function decodeExp () {
  const expireTime = localStorage.getItem('expTime')
  if (!expireTime) {
    const token = localStorage.getItem('token')
    if (token) {
      const decoded = VueJwtDecode.decode(token)
      const expTime = decoded['exp']
      localStorage.setItem('expTime', expTime)
      return localStorage.getItem('expTime')
    }
  } else {
    return localStorage.getItem('expTime')
  }
}
export default {
  name: 'App',
  sockets: {
    connect: function () {
      this.$socket.emit('authentication', {token: localStorage.getItem('token')})
    }
  },
  data () {
    return {
      paddingLeft: null,
      renderingFooterPadding: false
    }
  },
  components: {
    Footer
  },
  watch: {
    $route (to, from) {
      this.footerChanging()
    }
  },
  beforeMount () {
    const localLang = localStorage.getItem('lang')
    this.$store.dispatch('common/getLanguages')
      .then(() => {
        if (!localLang) { // need to get language by user ip and save that data into localStorage
          let ipAddress = localStorage.getItem('ipAddress')
          if (!ipAddress) {
            // Here we are adding core js ajax request because no need to send x-lang header via axiosApi
            const xhr = new XMLHttpRequest()
            xhr.open('GET', process.env.IP_DETECT_URL, false) // synchrony
            xhr.send()
            if (xhr.status === 200 && xhr.responseText) {
              ipAddress = xhr.responseText.trim()
              localStorage.setItem('ipAddress', ipAddress)
            }
          }
          let storageIpLocation = localStorage.getItem('ipLocation')
          if (storageIpLocation) {
            storageIpLocation = JSON.parse(storageIpLocation)
          }
          if (!storageIpLocation) {
            if (ipAddress) {
              return this.$store.dispatch('common/getUserIpLocation', {ipAddress: ipAddress})
                .then((res) => {
                  if (res.data && res.data.ipLocation) {
                    localStorage.setItem('ipAddress', res.data.ipLocation.ip)
                    localStorage.setItem('ipLocation', JSON.stringify(res.data.ipLocation))
                    if (res.data.ipLocation.countryCode === 'AM') { // Armenia -> Language need to put hy
                      localStorage.setItem('lang', 'hy')
                    } else { // other country -> Language need to put en
                      localStorage.setItem('lang', 'en')
                    }
                  }
                  return true
                })
                .catch(console.error)
            } else {
              // default value
              localStorage.setItem('lang', 'en')
            }
          } else {
            this.$store.commit('common/SET_IP_LOCATION', {ipLocation: storageIpLocation})
            if (storageIpLocation.countryCode && storageIpLocation.countryCode === 'AM') { // Armenia -> Language need to put hy
              localStorage.setItem('lang', 'hy')
            } else { // other country -> Language need to put en
              localStorage.setItem('lang', 'en')
            }
            return true
          }
        }
        return true
      })
      .then(() => {
        this.$store.dispatch('common/setLang', localStorage.getItem('lang'))
      })
      .catch(console.error)
  },
  mounted () {
    this.footerChanging()
    this.getGiverInfo()
    addEventListener('resize', this.footerChanging)
  },
  beforeUpdate () {
    setInterval(() => {
      let token = localStorage.getItem('token')
      let exp = localStorage.getItem('expTime')
      let expiryDate = new Date(exp * 1000)
      if (expiryDate && token && (Date.now() > expiryDate)) {
        localStorage.removeItem('token')
        localStorage.removeItem('expTime')
        this.logOut()
      }
    }, 0)
  },
  computed: {
    sidebarIsOpened () {
      return {
        'sidebar-opened': this.$store.state.sidebar.sidebarIsOpen,
        'sidebar-closed': !this.$store.state.sidebar.sidebarIsOpen,
        'swipe-direction': this.$store.state.sidebar.swipeDir
      }
    }
  },
  methods: {
    logOut () {
      this.$store.dispatch('auth/signOut')
      this.$store.dispatch('profile/clearUserData')
      this.$store.dispatch('profile/clearCategories')
      this.$router.push('/')
    },
    footerChanging () {
      if (window.matchMedia('(min-width: 960px)').matches) {
        if (this.$route.name === 'products' || this.$route.name === 'product' || this.$route.name === 'Needs' || this.$route.name === 'need') {
          this.paddingLeft = 300
        } else {
          this.paddingLeft = null
        }
      } else { this.paddingLeft = null }
    },
    swipe (direction) {
      if (document.querySelector('.quotes-section')) {
        let element = document.querySelector('.quotes-section')
        let position = element.getBoundingClientRect()
        if (position.top > window.innerHeight && position.bottom >= 0 && window.innerWidth < 1264) {
          this.$store.dispatch('sidebar/detectSwipeDir', direction)
        }
      } else {
        let routs = ['product', 'ProfileMyProducts', 'ProfileSettings']
        if (window.innerWidth < 1264 && !routs.includes(this.$route.name)) {
          this.$store.dispatch('sidebar/detectSwipeDir', direction)
        }
      }
    },
    getGiverInfo () {
      this.$store.dispatch('products/getGiverInfo').then((res) => {
      }).catch(console.error)
    }
  },
  created () {
    // this.$store.dispatch('products/setDefaultMetas').then((res) => {
    // }).catch(console.error)
    let expireTime = decodeExp()
    setInterval(() => {
      expireTime = decodeExp()
      if (expireTime && expireTime <= (Date.now() / 1000 + 120)) { // still 120 seconds the token is valid, we are refreshing it
        this.$store.dispatch('auth/refreshToken', {token: localStorage.getItem('token')})
          .then(resRefreshToken => {
            if (resRefreshToken.data && resRefreshToken.data.token) {
              const newUserData = decodeJwtToken()
              localStorage.setItem('token', resRefreshToken.data.token)
              localStorage.setItem('expTime', newUserData['exp'])
            } else {
              this.$store.dispatch('auth/signOut')
            }
          })
          .catch(() => {

          })
      }
    }, 60000)
    if (expireTime && expireTime <= (Date.now() / 1000 + 60)) { // if token isn't valid, we are logout user
      this.$store.dispatch('auth/signOut')
    }
    if (window.Notification && Notification.permission !== 'granted') {
      Notification.requestPermission(function (status) {
        if (Notification.permission !== status) {
          Notification.permission = status
        }
      })
    }
  },
  destroyed () {
    removeEventListener('resize', this.footerChanging)
  }
}
</script>

<style lang="scss">
@import '../node_modules/font-awesome/css/font-awesome.min.css'; // Ensure you are using css-loader
@import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
@import '../node_modules/vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
@import '../node_modules/swiper/dist/css/swiper.css';
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800,900');
@import './assets/sass/main.scss';
#app {
  /*font-family: 'Montserrat', 'Mardoto',  sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue